export default function(options){
    return {
        base: process.env.BASE_URL,
        routes: options
    }
}